<template>
  <div class="home">
    <main>
      <p>The UEFA National Associations Stadium and Security Unit works with its partners to ensure safe, secure and welcoming conditions for all football matches hosted across Europe. The unit’s aim is to improve safety and security, by integrating strategic, tactical and operational levels, applying a multi-agency approach and using best practice. </p>
      <p>The UEFA Stadium and Security Strategy Programme 2017–21 drives the unit’s efforts to keep ahead of safety and security risks and incidents. The Programme particularly targets national associations which are experiencing the greatest problems, together with countries that will host future finals and UEFA EURO 2020 matches. Training and support is one of the main areas in the UEFA toolbox that catalogues the unit’s products and services, next to strategy, auditing, guidance and good practice. </p>
    </main>

    <figure>
      <img :src="require('@/assets/lap-topper@2x.png')" />
    </figure>

    <aside>
      <vue-plyr ref="plyr" :options="options">
        <video :poster="poster" :src="introVideo">
          <source :src="introVideo" type="video/mp4" size="1024">
        </video>
      </vue-plyr>
    </aside>

    <footer>
      <a :href="pdf" download target="_blank" class="btn inline"><span>Download PDF</span><i class="material-icons">get_app</i></a>
      <router-link to="/quick-event" class="btn light inline"><span>Quick Event</span><i class="material-icons">filter_list</i></router-link>
      <router-link to="/code" class="btn light inline"><span>Access Code</span><i class="material-icons">login</i></router-link>
    </footer>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {},
  data () {
    return {
      options: {
        autoplay: false
      },
      introVideo: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/UEFA+STRATEGY+PROGRAMME+2017-2021.mp4",
      poster: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/thumbs/uefa-intro-poster.jpg",
      pdf: "https://s3.eu-central-1.amazonaws.com/sssponline.live/prototype/UEFA+Brochure+toolkit.pdf"
    }
  },
  mounted () {
    this.$store.dispatch('traineeStatusModule/setViewedIntro', false);
  }
}
</script>

<style lang="scss" scoped>
.home {
  position: relative;
  max-width: var(--container-width);
  margin: 0 auto;
  display: grid;
  grid-template-areas: 
    ". main ."
    "video video video"
    ". buttons .";
  grid-template-columns: 20px 1fr 20px;
  grid-row-gap: 2rem;

  @media all and (min-width: 700px) {
    grid-template-areas: 
      ". main figure ."
      "video video video video"
      ". buttons buttons .";
    grid-template-columns: 25px 2fr 1fr 25px;
  }

  main {
    grid-area: main;
    color: var(--primary);
  }
  figure {
    grid-area: figure;

    img {
      max-height: 290px;
    }

    @media all and (max-width: 699px) {
      display: none;
    }
  }
  aside {
    grid-area: video;
  }
  footer {
    grid-area: buttons;

    button, a {
      width: 100%;
      margin-bottom: 1rem;

      @media all and (min-width: 700px) {
        width: auto;
        margin-right: 1rem;        
      }
    }
  }
}
</style>